import * as React from "react";
import { cn } from "@/lib/utils";

const Input = React.forwardRef(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "tw:flex tw:h-9 tw:w-full tw:rounded-md tw:border tw:border-gray-300 tw:bg-transparent tw:px-3 tw:py-1 tw:text-sm tw:shadow-sm tw:outline-none tw:transition-colors tw:file:border-0 tw:file:bg-transparent tw:file:text-sm tw:file:font-medium tw:placeholder:text-gray-400 tw:focus:border-brand-secondary tw:focus:ring-2 tw:focus:ring-blue-200 tw:disabled:cursor-not-allowed tw:disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
